let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cEt9b"), load("tLGOl")]).then(() => parcelRequire('anKEx'));